import Image from "next/image";

export default function CopernicusBadge({ size = 24, compact = false }) {
  const image = (
    <Image
      src="/copernicus.ico"
      alt="Colaborador en el programa Copernicus"
      width={size}
      height={size}
    />
  );

  if (compact) {
    return image;
  }

  return (
    <div className="mt-5 flex flex-col items-center justify-center gap-1">
      <p className="text-sm text-gray-500">
        Colaborador en el programa Copernicus.
      </p>
      {image}
    </div>
  );
}
